import { render } from "./ConversationMessage.vue?vue&type=template&id=20f3d036&scoped=true"
import script from "./ConversationMessage.vue?vue&type=script&lang=js"
export * from "./ConversationMessage.vue?vue&type=script&lang=js"

import "./ConversationMessage.vue?vue&type=style&index=0&id=20f3d036&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f3d036"]])

export default __exports__